import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faArrowUp, faArrowDown, faSync } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import baseURL from '../../url';
import './BannerData.css'
import NewBanner from '../NewBanner/NewBanner';
export default function BannerData() {
    const [banners, setBanners] = useState([]);
    useEffect(() => {
        cargarBanners();

    }, []);
    const cargarBanners = () => {
        fetch(`${baseURL}/bannersGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setBanners(data.banner || []);
                console.log(data.banner)
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const guardarLink = (idBanner, link) => {
        fetch(`${baseURL}/bannerUpdate.php`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ idBanner, link })
        })
            .then(response => response.json())
            .then(data => {
                if (data.mensaje) {
                    toast.success(data.mensaje);
                    cargarBanners();
                } else if (data.error) {
                    toast.error(data.error);
                }
            })
            .catch(error => {
                console.error('Error al actualizar el link:', error);
                toast.error('Error de conexión al guardar el enlace.');
            });
    };

    const eliminarBanner = (idBanner) => {
        // Reemplaza el window.confirm con SweetAlert2
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/bannerDelete.php?idBanner=${idBanner}`, {
                    method: 'DELETE',
                })
                    .then(response => response.json())
                    .then(data => {
                        Swal.fire(
                            '¡Eliminado!',
                            data.mensaje,
                            'success'
                        );
                        cargarBanners();
                    })
                    .catch(error => {
                        console.error('Error al eliminar la Producto:', error);
                        toast.error(error);
                    });
            }
        });
    };
    return (
        <div className='BannerContainer'>
            <NewBanner />
            <div className='BannerWrap'>
                {
                    banners.map(item => (
                        <div className='cardBanner' key={item.idBanner}>
                            <div className='cardBannerPreview'>
                                {item.tipo === 'video' ? (
                                    <video src={item.imagen} muted playsInline style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                ) : (
                                    <img src={item.imagen} alt="banner" />
                                )}
                                <button className='btnBannerDelete' onClick={() => eliminarBanner(item.idBanner)}>
                                    <FontAwesomeIcon icon={faTrash} />
                                </button>
                            </div>
                            <div className='cardBannerActions'>
                                <input
                                    type="url"
                                    placeholder="Enlace de redirección (https://...)"
                                    value={item.link || ''}
                                    onChange={(e) => {
                                        const updated = banners.map(b => b.idBanner === item.idBanner ? { ...b, link: e.target.value } : b);
                                        setBanners(updated);
                                    }}
                                    style={{
                                        width: '100%',
                                        padding: '6px',
                                        fontSize: '12px',
                                        borderRadius: '6px',
                                        border: '1px solid #ccc',
                                        boxSizing: 'border-box'
                                    }}
                                />
                                <button
                                    onClick={() => guardarLink(item.idBanner, item.link)}
                                    style={{
                                        marginTop: '6px',
                                        width: '100%',
                                        padding: '6px',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        background: 'var(--color1)',
                                        color: '#fff',
                                        border: 'none',
                                        borderRadius: '6px',
                                        cursor: 'pointer',
                                        transition: '0.2s'
                                    }}
                                >
                                    Guardar Enlace
                                </button>
                            </div>
                        </div>
                    ))
                }

            </div>

        </div>
    )
}
